import { useEffect, useState } from 'react';
import { IQuestion, IAnswer } from '../data/interfaces';
import Answer from './answer';
import Correct from './correct';

type Props = {
  category: string;
  question: IQuestion;
  hasAnswer: boolean;
  examFinished?: boolean;
  onSelect: (correct: boolean) => void;
};

export default ({
  category,
  question,
  hasAnswer,
  examFinished,
  onSelect,
}: Props) => {
  const [shouldCorrectSelected, setShouldCorrectSelected] = useState(false);
  const [selectDone, setSelectDone] = useState(false);

  const handleSelect = (correct: boolean) => {
    onSelect(correct);
    if (!correct) {
      setShouldCorrectSelected(true);
    }
    setSelectDone(true);
  };

  const answers = question.answers.map((answer: IAnswer) => {
    return (
      <Answer
        sort={question.sort}
        answer={answer}
        correct={question.correct}
        isCorrectSelected={shouldCorrectSelected}
        selectDone={selectDone}
        onSelect={handleSelect}
      />
    );
  });

  useEffect(() => {
    if (examFinished) setSelectDone(true);
  }, [examFinished]);

  return (
    <div className="question" data-category={category}>
      <span className="number">{question.sort}. </span>
      <span className="q_text">{question.question}</span>

      <div className="answers">{answers}</div>

      {hasAnswer && <Correct correct={question.correct} />}
    </div>
  );
};
